module.exports = __webpack_public_path__ + "img/b6.56b13ac.png";